import { useSelector } from "react-redux";
import { useGetCompletedTodosQuery } from "../features/api/apiSlice";

export default function CompletedHeader() {
    const { completeFilter } = useSelector((state) => state.filter);
    const { data: completedTodos, isError, isLoading, refetch: refetchCompletedTodos } = useGetCompletedTodosQuery(completeFilter);

    const clearHandler = () => {
        if (!isError && !isLoading && completedTodos?.length > 0) {
            clearCompletedTasks();
        }
    };

    async function clearCompletedTasks() {
        console.log("ok");
        let promises = [];
        completedTodos.forEach(todo => {
            console.log(todo);
            const promise = fetch(`https://video-server-ar.herokuapp.com/todos/${todo.id}`, {
                method: "DELETE"
            });
            promises.push(promise);
        });
        await Promise.all(promises);
        refetchCompletedTodos();
    }
    return (
        <div>
            <h1 className="bg-gray-100 px-4 py-4">Completed Tasks</h1>
            <ul className="flex justify-between my-4 text-xs text-gray-500">
                <li className="cursor-pointer" onClick={clearHandler}>
                    Clear completed
                </li>
            </ul>
        </div>
    );
}
